module.exports = __webpack_public_path__ + "static/media/joystick.4993166b.png";